import { SeoModule } from '@client/app/pages/seo/seo.module';
import { PagesOverviewModule } from '@client/app/pages/pages/pages-overview.module';
import { InventoryModule } from '@client/app/pages/inventory/inventory.module';
import { NgModule } from '@angular/core';
import { CustomerPickerModule } from '@client/app/pages/customer-picker/customer-picker.module';
import { AdminModule } from '@client/app/pages/admin/admin.module';
import { StatisticsModule } from './statistics/statistics.module';
import { UpgradeQaModule } from '@client/app/pages/qa/qa.module';
import { UpgradePageFixModule } from '../modules/page-fix/page-fix.module';

@NgModule({
    imports: [
        SeoModule,
        InventoryModule,
        PagesOverviewModule,
        CustomerPickerModule,
        AdminModule,
        StatisticsModule,
        UpgradeQaModule,
        UpgradePageFixModule,
    ],
})

export class PagesModule {}
